// @flow

import React, { type Node, useEffect, useRef } from 'react';
import { usePayment } from '../context';
import { isSafeUrl } from '@tectonics/utils/url';
import {
  Container,
  Content,
  CheckmarkIcon,
  Title,
  Subtitle,
  ReturnLink,
} from './success-screen.styles';

function getSafeRedirectUrl(redirectUrl: ?string): ?string {
  if (!redirectUrl || !isSafeUrl(redirectUrl)) return null;
  return redirectUrl;
}

export function SuccessScreen(): Node {
  const { data } = usePayment();
  const redirectUrl = getSafeRedirectUrl(data.redirectUrlAfterPayment);
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!redirectUrl || hasRedirected.current) return;
    hasRedirected.current = true;
    window.location.assign(redirectUrl);
  }, [redirectUrl]);

  return (
    <Container>
      <Content>
        <CheckmarkIcon>
          <CheckmarkSvg />
        </CheckmarkIcon>

        <Title>Pago realizado con éxito</Title>
        {redirectUrl ? (
          <Subtitle>
            Vuelve a la tienda para acompañar tu compra.
          </Subtitle>
        ) : null}

        {redirectUrl ? (
          <ReturnLink as="a" href={redirectUrl}>
            Volver a la tienda
          </ReturnLink>
        ) : null}
      </Content>
    </Container>
  );
}

export function CheckmarkSvg(): Node {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="18.5" stroke="currentColor" strokeWidth="2" fill="none" />
      <path d="M12 20L17.5 25.5L28 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}
